<template>
  <div id="app">
    <router-view
      name="header"
      :key="$route.fullPath"
      @clickOpenCaixa="clickOpenCaixa"
    />
    <div class="wrapper">
      <router-view
        :key="$route.fullPath"
        :isToOpenCaixa="isToOpenCaixa"
        @changeIsOpen="isToOpenCaixa = false"
      />
    </div>
    <router-view name="footer" />
    <div v-if="carregando == true" class="carregando">
      <img style="max-width: 120px;" :src="linkLogo" />

      <br />
      <br />Carregando...
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import storage from './services/storage';
import 'remixicon/fonts/remixicon.css';

import goToHome from './services/goToHome';
import service from './services';

export default {
  data() {
    return {
      linkLogo: this.retornaLinkLogo(),
      isToOpenCaixa: false,
      iconeCarregando: service.getEnvIconeCarregando(),
      carregando: false,
      bgColor: '#ffffff',
      tema: this.$funcoesTema.getTema(),
    };
  },
  methods: {
    retornaLinkLogo() {
      return process.env.VUE_APP_LOGO;
    },
    clickOpenCaixa() {
      this.isToOpenCaixa = true;
    },
    buscaTemaEmpresa() {
      this.carregando = true;
      service
        .getAll('Empresas', {}, 'GetTema?idEmpresa=null')
        .then(res => {
          this.carregando = false;
          storage.escreveStorage('tema', res.data[0].temaCor);
          this.tema = JSON.parse(res.data[0].temaCor);
        })
        .catch(error => {
          this.exibeErro = true;
          this.msgErro = 'Não foi possível Buscar Tema! \n\n ' + error;
          this.carregando = false;
        });
    },
    getTema() {
      this.buscaTemaEmpresa();
    },
  },
  mounted() {
    this.getTema();
    storage.subscribe(goToHome.goToHomeWhenLogoff);
    if (this.$route.query) {
      if (this.$route.query.fbclid)
        storage.escreveStorage('fbclid', this.$route.query.fbclid);
    }
  },
};
</script>

<style>
@import url('https://cdn.jsdelivr.net/gh/eliyantosarage/font-awesome-pro@main/fontawesome-pro-6.5.2-web/css/all.min.css');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css');

#app {
  background-color: v-bind(tema.corDeFundo);
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: v-bind(tema.corTextoPadrao) !important;
}

#app a {
  color: v-bind(tema.corTextoPadrao);
}

.modal-content {
  background-color: v-bind(tema.corDeFundo) !important;
  color: v-bind(tema.corTextoPadrao);
  border-radius: 10px !important;
  border: solid white 1px !important;
  padding: 10px !important;
}

.modal-content .close {
  color: v-bind(tema.corTextoPadrao);
}

#whitelabel {
  min-height: 56vh;
  padding: calc(100px + 1rem) 1rem 1rem;
  position: relative;
}
.box-interno {
  min-height: 56vh;
  padding-top: 120px;
  padding-bottom: 60px;
}

.card {
  color: #000;
}

.btn {
  border-radius: 0 !important;
}

.btn i {
  font-size: 16px;
}

body:not(.logged-page) .form-check .form-check-sign::before,
body:not(.logged-page) .form-check .form-check-sign::after {
  border: 1px solid v-bind(tema.corTextoBotaoOutline) !important;
}

.logged-page .form-check .form-check-sign::before,
.logged-page .form-check .form-check-sign::after {
  border: 1px solid v-bind(tema.corDeTextoPaginasInternas) !important;
}

.tituloPagina {
  color: #fff;
}

.button-outline {
  font-weight: bold;
  color: v-bind(tema.corTextoBotaoOutline) !important;
  border: 2px solid v-bind(tema.corBordaBotaoOutline) !important;
  background-color: transparent !important;
  padding: 11px 23px;
  border: none;
}

.button-outline:hover {
  border: 2px solid v-bind(tema.corBordaBotaoOutlineHover) !important;
  color: v-bind(tema.corTextoBotaoOutlineHover) !important;
}

/*DEGRADES*/
.btn-degrade,
.categoria-selecionada {
  background-image: linear-gradient(
    90deg,
    v-bind(tema.degradeCor1),
    v-bind(tema.degradeCor2)
  ) !important;
  color: v-bind(tema.corTextoBotao) !important;
}

.dropdown .btn-primary {
  background-color: v-bind(tema.corFundoBotaoFormularios);
  color: v-bind(tema.corTextoBotaoFormularios) !important;
}

.btn-degrade:hover {
  background-image: linear-gradient(
    90deg,
    v-bind(tema.degradeCor1Hover),
    v-bind(tema.degradeCor2Hover)
  ) !important;
  color: v-bind(tema.corTextoBotaoHover) !important;
}

.btn-brilho,
.card-selecionado {
  -webkit-box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1) !important;
  -moz-box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1) !important;
  box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1) !important;
}

.bootstrap-switch {
  background-color: rgba(255, 255, 255, 0.8) !important;
  -webkit-box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1);
  -moz-box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1);
  box-shadow: -1px -1px 19px 2px v-bind(tema.degradeCor1);
}
.bootstrap-switch .bootstrap-switch-label {
  background-color: v-bind(tema.degradeCor1);
  background-image: linear-gradient(
    90deg,
    v-bind(tema.degradeCor1),
    v-bind(tema.degradeCor2)
  ) !important;
}
.bootstrap-switch .bootstrap-switch-container {
}

.menu {
  background-color: v-bind(tema.corDoBackGroundTopo) !important;
  color: #ffffff !important;
}

/*MENU E MENU MOBILE*/
.sidebar-collapse .navbar-collapse:before {
  background: v-bind(
    tema.corDoBackGroundMenuMobile
  ); /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    v-bind(tema.corDoBackGroundMenuMobile) 0%,
    v-bind(tema.corDoBackGroundMenuMobile2) 100%
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    v-bind(tema.corDoBackGroundMenuMobile) 0%,
    v-bind(tema.corDoBackGroundMenuMobile2) 100%
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    v-bind(tema.corDoBackGroundMenuMobile) 0%,
    v-bind(tema.corDoBackGroundMenuMobile2) 100%
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(
    v-bind(tema.corDoBackGroundMenuMobile) 0%,
    v-bind(tema.corDoBackGroundMenuMobile2) 100%
  ); /* Standard syntax (must be last) */
}

.menu-person {
  color: #646464;
  background-color: #ffffff;
}

.linkMenu,
.linkDropMenu a {
  color: v-bind(tema.corDosLinksMenu) !important;
}

.nav-item a {
  color: v-bind(tema.corDosLinksMenu) !important;
}

.nav-item a:hover {
  opacity: 0.3;
}

.linkMenu:hover,
.linkDropMenu a:hover {
  color: #f6c757 !important;
}

.linkDropMenu .show a,
.linkDropMenu .show a:hover {
  color: v-bind(tema.corTextoPadrao) !important;
}

.nav-open .navbar .show a,
.nav-open .navbar .linkDropMenu .show a:hover {
  color: #f6c757 !important;
}

.sidebar-collapse .navbar .navbar-toggler-bar {
  background: #f6c757 !important;
}

.navbar-toggler:hover .navbar-toggler-bar {
  background: #f6c757 !important;
}

.menu-navbar,
.page-header {
  background-color: v-bind(tema.corDoBackGroundTopo) !important;
  color: #ffffff !important;
}

.impagavel {
  color: v-bind(tema.corDeTextoTituloItemHover);
}

.item-saldo {
  font-weight: bold;
  border-radius: 10px;
  padding: 7px;
  text-decoration: none;
  color: v-bind(tema.corDaBordaSaldo);
  border: 1px solid v-bind(tema.corDaBordaSaldo);
  background-color: v-bind(tema.corDeFundoSaldo) !important;
}

.item-saldo:hover {
  color: v-bind(tema.corDaBordaSaldoHover);
  border: 1px solid v-bind(tema.corDaBordaSaldoHover);
  background-color: v-bind(tema.corDeFundoSaldoHover) !important;
}

.item-saldo span {
  color: v-bind(tema.corDoTextoSaldo) !important;
}

.item-saldo:hover span {
  color: v-bind(tema.corDoTextoSaldoHover) !important;
}

.item-saldo i {
  color: v-bind(tema.corDoIconeSaldo) !important;
}

.item-saldo:hover i {
  color: v-bind(tema.corDoIconeSaldoHover) !important;
}

html:not(.nav-open) .menu-navbar .dropdown-menu {
  background-color: v-bind(tema.corDeFundoMenuDropDown) !important;
}

html:not(.nav-open) .menu-navbar .dropdown-menu:before {
  color: v-bind(tema.corDeFundoMenuDropDown) !important;
}

html:not(.nav-open) .menu-navbar .dropdown-menu a {
  color: v-bind(tema.corDeTextoMenuDropDown) !important;
}

html:not(.nav-open) .menu-navbar .dropdown-menu a:hover {
  color: v-bind(tema.corDeTextoMenuDropDownHover) !important;
}

/*RODAPE*/

.footer {
  background-color: v-bind(tema.corDeFundoDoRodape) !important;
  color: v-bind(tema.corDeTextoDoRodape) !important;
}

.footer .nav-link {
  color: v-bind(tema.corDosLinksDoRodape) !important;
}

.footer .nav-link:hover {
  color: v-bind(tema.corDosLinksDoRodapeHover) !important;
}

/*ULTIMAS ABERTURAS*/
.ultimasAberturas {
  background-color: v-bind(tema.corDeFundoUltimasAberturas) !important;
}

.ultimasAberturas .tituloAberturas {
  background-color: v-bind(tema.corDeFundoTituloUltimasAberturas) !important;
  color: v-bind(tema.corDeTextoTituloUltimasAberturas) !important;
  border-color: v-bind(tema.corDeBordaTituloUltimasAberturas) !important;
}

.ultimasAberturas .tituloAberturas i {
  color: v-bind(tema.corDeRecTituloUltimasAberturas) !important;
}

.ultimasAberturas .sliderBoxBg {
  background-color: v-bind(tema.corDeFundoItemUltimasAberturas) !important;
}

.ultimasAberturas .avatarBg .vue-avatar--wrapper {
  background-color: v-bind(tema.corDeFundoAbreviacao) !important;
}

.ultimasAberturas .avatarColor .vue-avatar--wrapper {
  color: v-bind(tema.corDeTextoAbreviacao) !important;
}

.ultimasAberturas .sliderValor {
  background-color: v-bind(tema.corDeFundoValorUltimasAberturas) !important;
  color: v-bind(tema.corDeTextoValorUltimasAberturas) !important;
}

/*BANNERS*/
.banner-desk {
  background-color: v-bind(tema.corDeFundoDoBoxBanner) !important;
  color: v-bind(tema.corTextoBoxBanner) !important;
}

/*FILTRO */
.filtro {
  background-color: v-bind(tema.corDeFundoFiltro) !important;
  color: v-bind(tema.corDeTextoItensFiltro) !important;
}

.filtro .resetFilter {
  color: v-bind(tema.corDeLinkResetFiltros) !important;
}

.filtro .categoria {
  background-color: v-bind(tema.corDeFundoItensFiltro) !important;
  color: v-bind(tema.corDeTextoItensFiltro) !important;
  border: 1px solid v-bind(tema.corDeBordaItensFiltro) !important;
}

.filtro .categoria-selecionada {
  color: v-bind(tema.corDeTextoItensFiltroSelecionado) !important;
}

/*COMO FUNCIONA HOME*/
.comoFuncionaHome .box-como-funciona {
  background-color: v-bind(tema.corDeFundoBoxComoFunciona) !important;
}

.orange {
  color: v-bind(
    tema.corDeTextoTituloDestaqueBoxesPaginaComoFunciona
  ) !important;
}

.title {
  color: v-bind(tema.corDeTextoPaginasInternas);
}

.subtitle {
  color: v-bind(
    tema.corDeTextoTituloDestaqueBoxesPaginaComoFunciona
  ) !important;
  font-weight: 700;
}

.h1 span {
  color: v-bind(
    tema.corDeTextoTituloDestaqueBoxesPaginaComoFunciona
  ) !important;
}

.comoFuncionaHome .setas {
  color: v-bind(tema.corDeTextoSetas) !important;
}

/*BOX DETALHES*/
.wheel-item {
  background-color: v-bind(tema.corDeFundoDaRoleta) !important;
}

.wheel-item .conteudo-wheel h5 {
  color: v-bind(tema.corTextoTituloItemRoleta) !important;
}

.wheel-item .conteudo-wheel .valorItem {
  color: v-bind(tema.corTextoValorItemRoleta) !important;
}

.box-itens .box-principal {
  border: 1px solid v-bind(tema.corDeBordaDeDetalheDaCaixa) !important;
  background-color: v-bind(tema.corDeFundoBox) !important;
}

.box-itens .box {
  background-color: v-bind(tema.corDeFundoItem) !important;
}

.box-itens .box:hover {
  background-color: v-bind(tema.corDeFundoItemHover) !important;
}

.box-itens .box .odd {
  color: v-bind(tema.corDeTextoOddItem) !important;
}

.box-interno .box-itens {
  background-color: v-bind(tema.corDeFundoDaListagemDeItens) !important;
}

.box-itens .titulo {
  color: v-bind(tema.corTextoTituloListagemItens) !important;
}

.box-itens .box .titulo {
  color: v-bind(tema.corDeTextoTituloItem) !important;
}

.box-itens .box:hover .titulo {
  color: v-bind(tema.corDeTextoTituloItemHover) !important;
}

.box-itens .box .badge-valor {
  background-color: v-bind(tema.CorDeFundoValorItem) !important;
  color: v-bind(tema.CorDeTextoValorItem) !important;
}

.box-itens .box:hover .badge-valor,
.preco-modal .badge-valor {
  background-color: v-bind(tema.CorDeFundoValorItemHover) !important;
  color: v-bind(tema.CorDeTextoValorItemHover) !important;
}

.box-itens .sorteado .vcganhou {
  color: v-bind(tema.corDeTextoDestaque) !important;
}

.wheel-pointer {
  border-left: 0.25em solid v-bind(tema.corDeTextoDestaque) !important;
  border-right: 0.25em solid v-bind(tema.corDeTextoDestaque) !important;
  -webkit-box-shadow: 0px 0px 42px 6px v-bind(tema.corDeTextoDestaque) !important;
  -moz-box-shadow: 0px 0px 42px 6px v-bind(tema.corDeTextoDestaque) !important;
  box-shadow: 0px 0px 42px 6px v-bind(tema.corDeTextoDestaque) !important;
}

.wheel-pointer:after {
  border-color: transparent transparent v-bind(tema.corDeTextoDestaque)
    transparent;
}

.btn-center {
  background-color: v-bind(tema.corDeTextoDestaque);
}

.icon-itens {
  color: v-bind(tema.corDeTextoDestaque);
}

.mobile-menu {
  background-color: v-bind(tema.corDoBackGroundMenuMobile);
}

.p-modal {
  color: v-bind(tema.corDeTextoDestaque);
}

.menu-button:hover {
  color: v-bind(tema.corDeTextoDestaque);
  transform: scale(1.1);
}

.menu-button {
  color: v-bind(tema.corTextoPadrao);
}

.btn-teste {
  background-color: v-bind(tema.corBordaBotaoOutline);
  color: #ffffff;
  border-radius: 7px !important;
}

.wheel-pointer:before {
  border-color: transparent transparent v-bind(tema.corDeTextoDestaque)
    transparent;
}

.box-itens .sorteado .preco {
  color: v-bind(tema.corDeTextoDoValor) !important;
}

/*PAGINAS Genericas*/
.box-interno .page-header {
  background-color: v-bind(tema.corDeFundoTituloPaginasGenericas) !important;
}

.box-interno .page-header .title {
  text-align: center;
  color: v-bind(tema.corDeTextoTituloPaginasGenericas) !important;
}

/*BOTOES*/
.btn-vender-item {
  background-color: v-bind(tema.corDeFundoBotaoVenderItem) !important;
  color: v-bind(tema.corDeTextoBotaoVenderItem) !important;
}
.btn-vender-item:hover {
  background-color: v-bind(tema.corDeFundoBotaoVenderItemHover) !important;
  color: v-bind(tema.corDeTextoBotaoVenderItemHover) !important;
}

.btn-solicitar-entrega {
  background-color: v-bind(tema.corDeFundoBotaoSolicitarEntrega) !important;
  color: v-bind(tema.corDeTextoBotaoSolicitarEntrega) !important;
}
.btn-solicitar-entrega:hover {
  background-color: v-bind(
    tema.corDeFundoBotaoSolicitarEntregaHover
  ) !important;
  color: v-bind(tema.corDeTextoBotaoSolicitarEntregaHover) !important;
}

.btn-whatsapp {
  background-color: v-bind(tema.corDeFundoBotaoPrimarioFormularios);
}

.btn-box-open {
  background-color: v-bind(tema.corDeFundoBotaoPrimarioFormularios);
}

.btn-box-success {
  background-color: v-bind(tema.corDeFundoBotaoPrimarioFormularios);
}

.btn-primario-formulario {
  background-color: v-bind(tema.corDeFundoBotaoPrimarioFormularios) !important;
  color: v-bind(tema.corDeTextoBotaoPrimarioFormularios) !important;
}
.btn-primario-formulario:hover {
  background-color: v-bind(
    tema.corDeFundoBotaoPrimarioFormulariosHover
  ) !important;
  color: v-bind(tema.corDeTextoBotaoPrimarioFormulariosHover) !important;
}

/*PAGINA COMO FUNCIONA*/
.como-funciona .box-preenchido {
  background-color: v-bind(tema.corDeFundoBoxesPaginaComoFunciona) !important;
  color: v-bind(tema.corDeTextoBoxesPaginaComoFunciona) !important;
}

.como-funciona .box-preenchido h4 {
  color: v-bind(tema.corDeTextoTituloBoxesPaginaComoFunciona) !important;
}

.como-funciona h2 {
  color: v-bind(
    tema.corDeTextoTituloDestaqueBoxesPaginaComoFunciona
  ) !important;
}

/*FAQ*/
.perguntas .card-item {
  border-left: 3px solid v-bind(tema.corDeBordaPerguntas) !important;
  background-color: v-bind(tema.corDeFundoPergunta) !important;
}
.perguntas .card-item .indice {
  background-color: v-bind(tema.corDeFundoNumeroPergunta) !important;
  color: v-bind(tema.corDeTextoNumeroPergunta) !important ;
}
.perguntas .card-item .resposta {
  background-color: v-bind(tema.corDeFundoResposta) !important;
  color: v-bind(tema.corDeTextoResposta) !important ;
}
.perguntas .card-item a {
  color: v-bind(tema.corDeTextoPergunta) !important ;
}

.perguntas .card-item i {
  color: v-bind(tema.corDaSeta) !important ;
}

/*AREA LOGADA*/
.logged-page .box-interno .menu-container .list-group-item {
  background-color: v-bind(tema.corDeFundoMenuInterno) !important;
  color: v-bind(tema.corDeTextoMenuInterno) !important ;
}

.logged-page .box-interno .menu-container .list-group-item a {
  color: v-bind(tema.corDeTextoMenuInterno) !important ;
}

.logged-page .conteudo-interno {
  background-color: v-bind(tema.corFundoPaginasInternas) !important;
  color: v-bind(tema.corDeTextoPaginasInternas) !important;
}

/*BOX HOME*/
.lista-de-caixas .box {
  background-color: v-bind(tema.corDeFundoDosBoxes) !important;
}

.lista-de-caixas .box:hover {
  background-color: v-bind(tema.corDeFundoBoxesHover) !important;
  border: solid 1px v-bind(tema.corDeFundoDoValor) !important;
}

.lista-de-caixas .box .nomeCaixa {
  color: v-bind(tema.corDeTextoTituloBoxes) !important;
}

.lista-de-caixas .box .badge-valor,
.modal-content .badge-valor {
  background-color: v-bind(tema.corDeFundoDoValor) !important;
  color: v-bind(tema.corDeTextoDoValor) !important;
}

.lista-de-caixas .box:hover .btn:not(.btn-desabilitado) {
  background-image: linear-gradient(
    90deg,
    v-bind(tema.degradeCor1Hover),
    v-bind(tema.degradeCor2Hover)
  ) !important;
  color: v-bind(tema.corTextoBotaoHover) !important;
}

.lista-de-caixas .box:hover .badge-valor {
  background-color: v-bind(tema.corDeFundoDoValorHover) !important;
  color: v-bind(tema.corDeTextoDoValorHover) !important;
}

.lista-de-caixas .box .btn-desabilitado {
  background-color: transparent !important;
  border: 1px solid v-bind(tema.corBordaBotaoDesabilitado) !important;
  color: v-bind(tema.corTextoBotaoDesabilitado) !important;
}
</style>
<style lang="scss">
.resetFilter {
  font-size: 12px;
  font-weight: 900 !important;
  cursor: pointer;
}
.labelAbrirCaixa {
  vertical-align: middle;
}
.categoria {
  cursor: pointer;
  font-size: 14px;
}

.categoria-selecionada {
  font-weight: bold;
}
.tab-content.tab-content-padding {
  padding: 20px;
}

.mobile-margin {
  margin-top: 100px;
}

.lista-de-caixas {
  display: flex;
  flex-direction: column;
  gap: 3rem;

  // grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  grid-gap: 0.6rem;
  padding: 0.6rem 0;

  max-width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(169px, 1fr));
  grid-gap: 0.5rem;
  grid-auto-flow: dense;
}

@media (min-width: 767.98px) {
  .lista-de-caixas {
    grid-template-columns: repeat(auto-fill, minmax(318px, 1fr));
    grid-gap: 0.6rem;
    padding: 0.6rem 0;
  }
}

.productImage,
.textosBoxes {
  transition: transform 0.5s ease;
}
.box:hover {
  .productImage {
    transform: scale(1.1) rotate(-20deg) !important;
    //margin-left: -30px;
  }
  .textosBoxes {
    //transform: scale(1.02);
    //transform: scale(1.02) translate(-2%, -2%);
  }
}

@media all and (min-width: 1024px) {
  .box {
    h4 {
      font-size: 16px;
    }
    img {
      width: 250px;
    }
    button {
      padding-top: 10px;
    }
  }
}

@media all and (min-width: 768px) and (max-width: 1600px) {
  .box {
    button {
      span {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
}
@media (max-width: 700px) {
  .box {
    .botoes {
      //display: block !important;
    }
  }
}
</style>
